<div mat-dialog-content>
  <div class="flex items-center justify-center flex-col w-full">
    <div class="relative size-10 m-4">
      <div class="double-bounce1 bg-[var(--primary)]"></div>
      <div class="double-bounce2 bg-[var(--primary)]"></div>
    </div>
    {{data}}
  </div>
</div>
